import {Navigate, Outlet, Route, Routes, useLocation} from "react-router-dom";
import Login from "../components/auth/Login";
import {useAuth} from "../contexts/AuthContext";
import Forbidden from "../components/auth/Forbidden";
import ForgotPassword from "../components/auth/ForgotPassword";
import MainLayout from "../components/layout/MainLayout";
import Logout from "../components/auth/Logout";
import React from "react";
import LoginAs from "../components/auth/LoginAs";
import Register from "../components/auth/Register";
import WorkbookQuestions from "../components/modules/workbooks/WorkbookQuestions";
import WorkbookList from "../components/modules/workbooks/WorkbookList";
import AllWorkbooks from "../components/modules/workbooks/AllWorkbooks";
import Embed from "../wp_embed/Embed";


export default function AiEcommRouter() {

    return (
        <Routes>

            {/* Embed routes */}
            <Route path="/embed/all_workbooks" element={<Embed viewType="all_workbooks" />} />
            <Route path="/embed/:workbookId" element={<Embed viewType="workbook" />} />
            <Route path="/embed" element={<Embed />} />

            <Route element={<ProtectedRoutes/>}>
                <Route element={<MainLayout/>}>
                    {/*<Route path="/dashboard" element={<Dashboard/>}/>*/}
                    <Route path="/forbidden" element={<Forbidden/>}/>
                    <Route path="/workbooks/all_workbooks" element={<AllWorkbooks/>}/>
                    <Route path="/workbooks/:id" element={<WorkbookQuestions/>}/>
                    <Route path="/users" element={<LoginAs/>}/>
                </Route>

            </Route>

            <Route element={<MainLayout/>}>
                <Route index element={<WorkbookList/>}/>
                <Route path="/logout" element={<Logout/>}/>
            </Route>

            {/* Public routes with main layout */}
            <Route element={<PublicRoute/>}>
                <Route element={<MainLayout/>}>
                    {/* Auth stuff */}
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword/>}/>
                    <Route path="/register" element={<Register/>}/>
                </Route>
            </Route>


        </Routes>
    );
}

const ProtectedRoutes = () => {
    const {currentUser, loading} = useAuth()
    const location = useLocation()
    return !loading && currentUser ? (
        <Outlet/>
    ) : (
        <Navigate to="/login" replace={true} state={{prev: location.pathname}}/>
    );
};
export const PublicRoute = ({requiredPermission}) => {
    const {currentUser, loading} = useAuth()
    if (loading) return <></>;
    if (currentUser) return <Navigate to="/" replace={true}/>;
    return <Outlet/>
};